<template>
  <div class="shot_wrapper">
    <ShotHeader
      :pickerOption="pickerOption"
      :date.sync="chooseDate"
      :text.sync="searchTxt"
      @submit="noticeSubmit"
      @filtrateNbhd="searchNbhdByArea">
    </ShotHeader>
    <NbhdList
      v-if="outlayerData"
      ref="listCp"
      :transport="outlayerData"
      :searchTxt="searchTxt"
      :noDataTip="tipNone"
      :loading="loading"
      showTab
      @submitMonit="submitMonitAction"
      key="nbhd_list-screen">
    </NbhdList>
  </div>
</template>

<script>
import ShotMixin from './mixin/ShotMixin'
import ShotHeader from './ShotHeaderCp'
import NbhdList from './NbhdList'
import Confirm from './confirm'
import Tip from './confirm/child/Tip'
import sucImg from '@/assets/submit_success.png'
import { submitMonitTask } from '@/utils/api'

export default {
  name: 'MonitShotScreen',
  components: { ShotHeader, NbhdList },
  mixins: [ ShotMixin ],
  data () {
    return {
      checkAll: true,
      screenType: null
    }
  },
  destroyed () {
    this.outlayerData = null
  },
  async created () {
    await this.getOrderNbhd()
  },
  methods: {
    async submitMonitAction ({ deviceGuids, nbhdCount, screenCount }) {
      console.log('提交监播任务:' + deviceGuids + ',小区数：' + nbhdCount, this.mTypes)
      if (!screenCount) return this.$message.warning('请至少选择一个屏幕')
      let param = {
        contentGuid: this.orderInfo.contentGuid,
        orderGuid: this.orderInfo.guid,
        // monitorType: '1',
        deviceGuids,
        nbhdCount,
        screenCount,
        targetDate: this.chooseDate,
        taskName: this.monitTaskName,
        camera: this.mTypes.indexOf('camera') > -1 ? 1 : 0, // 是否提交相机截图任务
        screen: this.mTypes.indexOf('screen') > -1 ? 1 : 0, // 是否提交屏幕截图任务
        downloadMethod: this.downWay // 下载方式
      }
      const res = await submitMonitTask(param)
      if (res && res.code === 0) {
        const tipProp = {
          img: sucImg,
          alt: '提交成功',
          text: '您可在“监播服务—任务列表”中查看截图进度。如有其他疑问请致电客服18030632371'
        }
        const propConf = { title: '提交成功', cancelBtnLabel: '确定' }
        Confirm.init('Tip', Tip, tipProp, propConf).then(info => {})
        this.$root.$emit('screenMonitTaskSuccess')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shot_wrapper {
  height: 100%;
  padding: 10px 20px 0;
}
</style>
